import React, { useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Auth from "./Auth";
import DarkModeButton from "./DarkModeButton";
import setAuthToken from "../utils/setAuthToken";
import Notification from "./Notification";
import InfoIcon from "@mui/icons-material/Info";
import packageJson from "../../package.json";
import { Tooltip } from "@mui/material";
import { motion } from "framer-motion";
import { navVariants } from "../utils/motion";
import { Nav } from "react-bootstrap";
import { loadFloorsList } from "../actions/adminAction";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const Navbar = ({ domain, activeTab, setActiveTab, setTabContent }) => {
  const user = useSelector((state) => state.auth.user);
  const dark = useSelector((state) => state.dark.data);
  const scanInfo = useSelector((state) => state.threeDFusion.scanInfo);
  const floorsList = useSelector((state) => state.admin.floorsList);
  const dispatch = useDispatch();

  const parseLiteLinks = (value) => {
    let parsed = value;
    for (let attempt = 0; typeof parsed === "string" && attempt < 2; attempt += 1) {
      try {
        parsed = JSON.parse(parsed);
      } catch (error) {
        console.error("Failed to parse VirbrixliteLink:", error);
        return [];
      }
    }
    if (parsed && !Array.isArray(parsed) && Array.isArray(parsed.links)) {
      parsed = parsed.links;
    }
    return Array.isArray(parsed) ? parsed : [];
  };

  // Fetch tab config for Virbrix lite clients
  useEffect(() => {
    if (domain?.includes("virbrixlite") && user?.client_id) {
      dispatch(loadFloorsList());

    }
  }, [domain, user?.client_id]);


  // const liteTabs = [
  //   {
  //     id: 1,
  //     name: "overview",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-825ec473-13fc-4309-bb45-e2b7bd098580/3aa2db7a-6b68-40e9-b5a7-aa23c04ee4cb",
  //     display: "Overview",
  //     client: [1],
  //   },
  //   {
  //     id: 2,
  //     name: "overview",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-3705868e-f773-48c9-bda0-58d22325a087/0f011b3f-2197-4f6c-8110-48c4d51ab7dd",
  //     display: "Overview",
  //     client: [32],
  //   },
  //   {
  //     id: 3,
  //     name: "floor1-centralKitchen",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-33a4fb75-89d6-4e57-9d91-01aaeda3d05b/d11b4b6c-c79d-40ba-a8a1-b88d07c15169",
  //     display: "Fl.1 - Central Kitchen",
  //     client: [32],
  //   },
  //   {
  //     id: 4,
  //     name: "floor2-dashboard",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-549ba96a-018d-4c58-83b4-16a01b2ce535/e07231a6-5142-48af-9c44-4f26b3ca641c",
  //     display: "Fl.2 - Dashboard",
  //     client: [32],
  //   },
  //   {
  //     id: 5,
  //     name: "floor2-map",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-ddd30532-77bd-46c2-9e22-018f4940a997/34b0b14a-ee31-45a8-848f-88acc442f368",
  //     display: "Fl.2 - Map",
  //     client: [32],
  //   },
  //   {
  //     id: 6,
  //     name: "floor3-dashboard",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-00842c4c-100f-4ab3-b17f-07a51b6a35a0/d7c7f70b-b671-4e1a-a361-81d88b5e351d",
  //     display: "Fl.3 - Dashboard",
  //     client: [32],
  //   },
  //   {
  //     id: 7,
  //     name: "floor3-map",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-ddd30532-77bd-46c2-9e22-018f4940a997/34b0b14a-ee31-45a8-848f-88acc442f368",
  //     display: "Fl.3 - Map",
  //     client: [32],
  //   },
  //   {
  //     id: 8,
  //     name: "floor4-dashboard",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-d70db069-ffdb-4ca8-9367-6ea6ea689f58/73dcbe5f-4815-40b9-b74a-b6ca824ffb52",
  //     display: "Fl.4 - Dashboard",
  //     client: [32],
  //   },
  //   {
  //     id: 9,
  //     name: "floor4-map",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-d543426d-e07c-4eb5-87dd-64b2e1c3b65a/1b73eb80-a1f1-496c-b5c6-7b125c303420",
  //     display: "Fl.4 - Map",
  //     client: [32],
  //   },
  //   {
  //     id: 10,
  //     name: "floor1-retirement_residence",
  //     src: "https://cloud.milesight-iot.com/#/shareDashboard/eu-central-1/d-49dfe6ad-5443-41b8-957f-db8db0368565/b058c742-a8b6-4bd8-a454-a0f0cf6516f6",
  //     display: "Fl.1 - Retirement Residence",
  //     client: [32],
  //   },

  //   {
  //     id: 11,
  //     name: "report-wizard",
  //     client: [32],
  //   },
  // ];

  const show3DFusion = useMemo(() => {
    if (
      user &&
      [1, 2].includes(user.role_id) &&
      domain === "virbrix" && user.client_id !== 36 &&
      scanInfo?.data &&
      scanInfo?.data?.length > 0
    ) {
      return true;
    }
    return false;
  }, [user, domain, scanInfo]);


const liteTabs = useMemo(() => {
  if (domain?.includes("virbrixlite") && floorsList?.length) {
    const combined = floorsList.reduce((acc, floor) => {
      if (!floor?.VirbrixliteLink) return acc;
      return acc.concat(parseLiteLinks(floor.VirbrixliteLink));
    }, []);
    return combined;
  }
  return [];
}, [domain, floorsList]);


  // Keep the embedded dashboard synchronized with the configured links.
  useEffect(() => {
    if (!Array.isArray(liteTabs) || liteTabs.length === 0) {
      setActiveTab("");
      setTabContent("");
      return;
    }

    const activeLink = liteTabs.find((tab) => tab?.name === activeTab);
    const selectedTab = activeLink || liteTabs[0];
    setActiveTab(selectedTab?.name || "");
    setTabContent(selectedTab?.src || "");
  }, [liteTabs, activeTab, setActiveTab, setTabContent]);


  return (
    <nav
      class={`navbar navbar-expand-lg ${dark ? "navbar-dark" : "navbar-light"
        } navbar-theme navbar-bg fixed-top shadow w-100`}
    >
      <motion.div
        class="container-fluid navbar-bg w-100 "
        variants={navVariants}
        initial="hidden"
        whileInView="show"
      >
        <NavLink
          class="navbar-brand"
          to={user !== null && user !== undefined && user.client_id !== 36 ? "/dashboard" : "/3dfusion"}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/Logo-AI-v3.png`}
            alt=""
            width={135}
          />
        </NavLink>
        {user !== null && user !== undefined && (
          <button
            class="navbar-toggler logout-btn"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
        )}
        {user !== null && user !== undefined && (
          <div
            class="collapse navbar-collapse navbar-bg h-100  p-2 py-lg-0 "
            id="navbarNavDropdown"
          >
            <ul class="navbar-nav navbar-bg mb-2 mb-lg-0">
              {/* Virbrix Page */}
              {/* Home */}
              <li class="nav-item mx-lg-3 align-middle p-0 d-block">
                {user !== null &&
                  user !== undefined &&
                  !domain?.includes("virbrixlite") && user.client_id !== 36 && (
                    <NavLink to="/dashboard">Home</NavLink>
                  )}
              </li>

              {/* Porfolio */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <li class="nav-item mx-lg-3 align-middle p-0 d-block">
                    {user !== null && user !== undefined && (
                      <NavLink to="/portfolio">
                        Portfolio
                        {/* <img
                        src="images/icons/new-icon.jpg"
                        width={30}
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "-15px",
                        }}
                      /> */}
                      </NavLink>
                    )}
                  </li>
                )}

              {/* 3D Fusion */}
              {show3DFusion && (
                <li class="nav-item mx-lg-3 align-middle p-0 d-block">
                  {user !== null && user !== undefined && (
                    <NavLink to="/3dfusion">
                      3D Fusion
                      {/* <img
                        src="images/icons/new-icon.jpg"
                        width={30}
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "-15px",
                        }}
                      /> */}
                    </NavLink>
                  )}
                </li>
              )}

              {/* AI Analytic feature */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <li class="nav-item mx-lg-3 align-middle p-0 d-block">
                    {user !== null && user !== undefined && (
                      <NavLink to="/chatbot">
                        Analytics Assistant
                        {/* <img
                        src="images/spark-icon.png"
                        width={30}
                        style={{
                          position: "absolute",
                          top: "-20px",
                          right: "-25px",
                        }}
                      /> */}
                      </NavLink>
                    )}
                  </li>
                )}
            </ul>

            {/* Virbrix Lite */}
            {user !== null &&
              user !== undefined &&
              domain?.includes("virbrixlite") && liteTabs?.length > 0 && (
                <>
                  {/* Milesights tab */}
                  {liteTabs?.map(
                    (item) =>
                      (
                        <>
                          <li class="nav-item mx-lg-3 align-middle p-0 d-block">
                            <Nav.Link
                              eventKey={`${item.name}`}
                              active={activeTab === `${item.name}`}
                              onClick={() => {
                                setActiveTab(`${item.name}`);
                                setTabContent(`${item.src}`);
                              }}
                              style={{
                                color:
                                  activeTab === `${item.name}`
                                    ? "#ffffff"
                                    : "#6c757d",
                                fontWeight:
                                  activeTab === `${item.name}`
                                    ? "bold"
                                    : "normal",
                                borderColor: "#112138",
                              }}
                            >
                              {item.display}
                            </Nav.Link>
                          </li>
                        </>
                      ),
                  )}

                  {/* Custom Feature - Reporting */}
                  <li class="nav-item p-0 d-block">
                    {user !== null &&
                      user !== undefined &&
                      user.client_id === 32 && (
                        <NavLink
                          eventKey={`report-wizard`}
                          active={activeTab === `report-wizard`}
                          onClick={() => {
                            setActiveTab(`report-wizard`);
                            setTabContent(`report-wizard`);
                          }}
                          style={{
                            color:
                              activeTab === `report-wizard`
                                ? "#ffffff"
                                : "#6c757d",
                            fontWeight:
                              activeTab === `report-wizard` ? "bold" : "normal",
                            borderColor: "#112138",
                          }}
                        >
                          Reporting
                        </NavLink>
                      )}
                  </li>
                </>
              )}

            {/* Right side */}
            <div class="d-flex align-items-center justify-content-center ms-auto navbar-bg gap-2">
              {/* Notification */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <div>
                    <Notification />
                  </div>
                )}

              {/* Version */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <div>
                    <Tooltip title={`version: ${packageJson.version}`}>
                      <InfoIcon />
                    </Tooltip>
                  </div>
                )}

              {/* Configuration */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <NavLink to="/admin/users">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#FFFFFF"
                    >
                      <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z" />
                    </svg>
                  </NavLink>
                )}

              {/* Documentation */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <NavLink to="/opensource">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#FFFFFF"
                    >
                      <path d="m384-336 56-58-86-86 86-86-56-58-144 144 144 144Zm192 0 144-144-144-144-56 58 86 86-86 86 56 58ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm280-590q13 0 21.5-8.5T510-820q0-13-8.5-21.5T480-850q-13 0-21.5 8.5T450-820q0 13 8.5 21.5T480-790ZM200-200v-560 560Z" />
                    </svg>
                  </NavLink>
                )}

              {/* Toogle dark light mode */}
              {[1].includes(user.role_id) &&
                !domain?.includes("virbrixlite") && (
                  <DarkModeButton dark={false} />
                )}
              <div className="d-flex align-items-center justify-content-start ms-0 ms-lg-5">
                {user !== null && user !== undefined && (
                  <>
                    <div className="navbar-user">
                      {user.email.split("@")[0]}
                    </div>
                    <Auth auth={false} domain={domain} idp={[]} />
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </motion.div>
    </nav>
  );
};

export default Navbar;
